import type {
  TwoFactorRepository,
  TwoFactorSetup,
  TwoFactorStatus,
} from '@core/repositories/TwoFactorRepository';
import { httpClient } from '@infrastructure/http/httpClient';
import { toAppError } from '@infrastructure/http/errorMapper';

interface StatusResponse {
  enabled: boolean;
}

interface SetupResponse {
  secret: string;
  qr_code_url: string;
}

interface RecoveryCodesResponse {
  recovery_codes: string[];
}

export class TwoFactorRepositoryImpl implements TwoFactorRepository {
  async status(): Promise<TwoFactorStatus> {
    try {
      const response = await httpClient.get<StatusResponse>('/two-factor');
      return { enabled: response.data.enabled };
    } catch (error) {
      throw toAppError(error);
    }
  }

  async enable(): Promise<TwoFactorSetup> {
    try {
      const response = await httpClient.post<SetupResponse>('/two-factor/enable');
      return { secret: response.data.secret, qrCodeUrl: response.data.qr_code_url };
    } catch (error) {
      throw toAppError(error);
    }
  }

  async confirm(code: string): Promise<string[]> {
    try {
      const response = await httpClient.post<RecoveryCodesResponse>('/two-factor/confirm', {
        code,
      });
      return response.data.recovery_codes;
    } catch (error) {
      throw toAppError(error);
    }
  }

  async disable(password: string): Promise<void> {
    try {
      await httpClient.delete('/two-factor', { data: { password } });
    } catch (error) {
      throw toAppError(error);
    }
  }

  async regenerateRecoveryCodes(): Promise<string[]> {
    try {
      const response = await httpClient.post<RecoveryCodesResponse>('/two-factor/recovery-codes');
      return response.data.recovery_codes;
    } catch (error) {
      throw toAppError(error);
    }
  }
}
